import Backbone from 'backbone'
import template from './initiatives-advanced-form.hbs'
import DateInput from 'scoreboard/components/date-input'
import _ from 'lodash'
import $ from 'jquery'
import FormView from 'scoreboard/components/form-view'
import MarkedField from 'scoreboard/components/marked-field'
import numericValidator from 'scoreboard/components/validators/numeric-validator'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import formHelper from 'scoreboard/components/form-helper'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import TagsChooser from 'scoreboard/components/tags-chooser'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import i18n from 'scoreboard/components/i18n'
import DataType from 'scoreboard/datasets/model/data-type'
const { CURRENCY } = DataType

var AdvancedForm = Backbone.View.extend({

	// this.model is an Model with at least 2 properties: goalFunction and expenditures

	tagName: 'form',

	className: 'form initiatives-advanced-form',

	events: {
		'click .expenditure-delete': 'deleteRow',
		'change tbody tr:last-child': 'addRow'
	},

	initialize: function(opts = {}) {
		this.options = opts
		this._markedFields = []
		var InitiativesAdvancedFormView = FormView.extend({
			test: this.test.bind(this),
			validate: this.validate.bind(this)
		})
		this.formView = new InitiativesAdvancedFormView({ el: this.el, submit: this.submit.bind(this) })
	},

	render: function() {
		this.$el.empty().append(template(this.context()))

		let goalFunctionValue = this.model.get('goalFunction') || 'linear'
		this.toggle = new LabeledToggle({
			options: [{
				value: 'linear',
				label: i18n.get('initiatives.goalFunctions.linear')
			}, {
				value: 's-curve',
				label: i18n.get('initiatives.goalFunctions.sCurve')
			}],
			value: goalFunctionValue
		})
		this.$('.goal-functions-container').append(this.toggle.el)
		this.toggle.render()
		this.listenTo(this.toggle, 'change', val => {
			this.formView.change()
			this.toggleExpenditures(val)
		})

		this.toggleExpenditures(goalFunctionValue)

		// keep a fresh copy of the add row to server as a template
		var lastRow = this.$('tbody tr:last-child')
		this.templateRow = lastRow.clone()

		// render all the expenditures
		var tbody = this.$('tbody')
		_.forEachRight(this.model.get('expenditures'), function(expenditure) {
			var row = this.templateRow.clone()
			tbody.prepend(row)
			this.row(row, expenditure)
		}.bind(this))

		this._tagsChooser = new TagsChooser({
			el: this.$('[name=tags]'),
			tags: this.model.get('tags'),
			globalTags: this.options.globalTags
		}).render()

		// setup the add row
		this.row(lastRow)
		lastRow.find('.expenditure-delete').hide()

		this.formView.start()
		this.covertButtonTooltips = new CovertButtonTooltips({ el: this.el })

		return this
	},

	context: function() {
		return {
			milestoneSelected: this.options.selectedType === 'milestone'
		}
	},

	row: function(el, expenditure) {
		el = $(el)
		var date
		if (expenditure) {
			el.data('id', expenditure.id)
			el.find('.amount').val(expenditure.amount)
			el.find('.label').val(expenditure.label)
			date = expenditure.date
		}

		// setup label field
		this._markedFields.push(new MarkedField({
			el: el.find('.label'),
			validator: requiredValidator
		}).render())
		// setup amount field
		this._markedFields.push(new MarkedField({
			el: el.find('.amount'),
			dataType: CURRENCY,
			currencyCode: this.model.get('currencyCode'),
			evaluator: numericEvaluator,
			validator: [requiredValidator, numericValidator]
		}).render())
		// setup date field
		this._dateInput = new DateInput({
			el: el.find('.date'),
			initialValue: date,
			required: true
		}).render()
		this._markedFields.push(this._dateInput)
	},

	toggleExpenditures: function(val) {
		this.$('.expenditures').toggle(val === 'linear')
		_.invokeMap(this._markedFields, 'removeTooltip')
	},

	addRow: function(e) {
		// we have to do this, or else if someone types into a new row and then
		// clicks on the delete button in a different row, the delete doesn't
		// register
		setTimeout(function() {
			// all existing rows should have a delete buttons
			this.$('.expenditure-delete').show()

			var row = this.templateRow.clone()
			row.find('.expenditure-delete').hide()
			this.$('.expenditure-row-new').removeClass('expenditure-row-new')
			this.$('tbody').append(row.addClass('expenditure-row-new'))
			this.row(row)

			// needed or the tooltips aren't in the right spot
			this.trigger('resize')
			_.invokeMap(this._markedFields, 'repositionTooltip')
		}.bind(this), 100)
	},

	deleteRow: function(e) {
		var row = $(e.currentTarget).closest('tr')

		var removedFields = []
		_.each(row.find('input'), function(input) {
			var removedField = $(input).data('view')
			removedFields.push(removedField)
			removedField.remove()
		})
		row.remove()

		this._markedFields = _.difference(this._markedFields, removedFields)

		this.formView.change(e)
	},

	// figure out which fields need to be validated (if the last row is
	// entirely blank, just ignore it)
	_getFieldsToValidate: function() {
		if (this.toggle.val() === 's-curve') {
			return []
		}

		var lastInputs = _.takeRight(this.$('input'), 3)
		// determine if any data was entered in the last fields
		var hasData = _.find(lastInputs, function(input) {
			return !_.isEmpty($(input).val())
		})
		return hasData ? this._markedFields : _.dropRight(this._markedFields, 3)
	},

	// test all the marked-fields for errors, and return the views with errors.
	// if there are no errors, returns null
	test: function() {
		return formHelper.test(this._getFieldsToValidate())
	},

	// validate the form, display any relevant error messages and return an
	// array of errors found.  if there are no errors, returns null
	validate: function() {
		return formHelper.validate(this._getFieldsToValidate())
	},

	submit: function(e) {
		e.preventDefault()

		// read data from the DOM
		var data = _.extend(formHelper.readFromDom(this.el),{
			goalFunction: this.toggle.val(),
			expenditures: []
		})
		// loop through all but last row
		var dataRows = _.initial(this.$('tbody tr'))
		_.each(dataRows, function(el, i) {
			data.expenditures.push({
				id: $(el).data('id'),
				label: $(el).find('.label').data('view').val(),
				amount: $(el).find('.amount').data('view').val(),
				date: $(el).find('.date').data('view').getIsoDate()
			})
		}.bind(this))

		this.trigger('done', data)
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap(this._markedFields, 'remove')
		_.invokeMap([this.formView, this.covertButtonTooltips,
			this._tagsChooser, this.toggle], 'remove')
	}

})

export default AdvancedForm

AdvancedForm.__filename__ = 'initiatives/edit/initiatives-advanced-form.js'
